import { X } from "lucide-react";

/** Confirmation dialog shown before redirecting to Google. */
export default function SignInPromptModal({ open, reason, onConfirm, onClose }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[200] bg-black/45 flex items-end sm:items-center justify-center p-4"
      onClick={onClose}
      data-testid="signin-prompt"
    >
      <div
        className="bg-white rounded-2xl w-full max-w-md shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-stone-200">
          <h3 className="text-base font-extrabold text-stone-900">Sign in to continue</h3>
          <button
            onClick={onClose}
            aria-label="Close"
            data-testid="signin-prompt-close"
            className="text-stone-500 hover:text-stone-900"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="px-5 py-5">
          <p className="text-stone-800 leading-relaxed text-[15px]" data-testid="signin-prompt-reason">
            {reason || "Sign in to save your favourites, track waterfalls you've visited, leave reviews and ask questions."}
          </p>
          <p className="text-xs text-stone-500 mt-3">
            We use Google to keep things secure — no extra password to remember. We never post or share anything to your Google account.
          </p>
        </div>

        <div className="flex items-center justify-end gap-2 px-5 py-4 bg-stone-50 border-t border-stone-100">
          <button
            type="button"
            onClick={onClose}
            data-testid="signin-prompt-cancel"
            className="px-4 py-2 rounded-full text-sm font-semibold text-stone-700 hover:bg-stone-100"
          >
            Not now
          </button>
          <button
            type="button"
            onClick={onConfirm}
            data-testid="signin-prompt-confirm"
            className="btn-at btn-at-green !px-5 inline-flex items-center gap-2"
          >
            <svg width="16" height="16" viewBox="0 0 48 48" aria-hidden="true">
              <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8a12 12 0 1 1 0-24c3 0 5.8 1.1 7.9 3l5.7-5.7C33.6 5.3 29 3.5 24 3.5 12.7 3.5 3.5 12.7 3.5 24S12.7 44.5 24 44.5c11.3 0 20.5-9.2 20.5-20.5 0-1.2-.1-2.3-.4-3.5z"/>
              <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C33.6 5.3 29 3.5 24 3.5 16.3 3.5 9.6 7.9 6.3 14.7z"/>
              <path fill="#4CAF50" d="M24 44.5c4.9 0 9.4-1.9 12.8-5l-5.9-5c-2 1.4-4.5 2.3-6.9 2.3-5.3 0-9.7-3.4-11.3-8l-6.6 5.1C9.5 40.1 16.2 44.5 24 44.5z"/>
              <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3a12 12 0 0 1-4.1 5.5l5.9 5C40.6 35.4 44.5 30.2 44.5 24c0-1.2-.1-2.3-.9-3.5z"/>
            </svg>
            Continue with Google
          </button>
        </div>
      </div>
    </div>
  );
}
